import request from 'helpers/request';
import LocalStorage from 'helpers/LocalStorage';
import RpcService from 'helpers/RpcService';
import RpcTypes from 'constants/rpcTypes';

export const getLocalization = (): Promise<any> => {
  const ticketNumbers = LocalStorage.get('lcTicketsPreview') || [];
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Localize_Dictionaries,
        payload: { ticketNumbers },
      },
    ],
  });
};

export const downloadLocaleTemplate = (requestData): Promise<any> => {
  return request({
    method: 'POST',
    url: 'app/localize/download',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: requestData,
    errorHandle: false,
  });
};

export const uploadLocaleFile = (requestData): Promise<any> => {
  return request({
    method: 'POST',
    url: 'app/localize/upload',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: requestData,
    errorHandle: false,
  });
};
